import type { Lottery } from '@lotta/shared/types-lottery-schemas';
import type { Expand } from '@lotta/shared/util-utilities';
import { DateTime } from 'luxon';

type RequiredLotteryProps = Expand<
  Pick<Lottery, 'lotteryStatus'> & {
    occurrence: Pick<Lottery['occurrence'], 'startDate'>;
  }
>;

/**
 * Delete Lottery
 *
 * Possible until first signup period start
 */
export const isDeleteLotteryAllowed = (
  lottery: RequiredLotteryProps,
  timezone: string,
  date: Date
) => {
  if (lottery.lotteryStatus !== 'PENDING') {
    return false;
  }

  // Allowed if signup have not started
  const startDate = DateTime.fromISO(lottery.occurrence.startDate, { zone: timezone }).startOf(
    'day'
  );
  return startDate.toJSDate() > date;
};
